<template>
  <div class="messenger-message-comment">
    <div class="messenger-message-comment__balloon">
      <div class="messenger-message-comment__from">
        От: {{ message.author.name }} ({{ message.author.email }})
      </div>
      <div class="messenger-message-comment__text">
        {{ message.comment }}
      </div>
    </div>
    <div class="messenger-message-comment__date">
      <messenger-date
        :date="message.created_at"
      />
    </div>
  </div>
</template>

<script>
import MessengerDate from '../../../components/MessengerDate.vue'

export default {
  components: {
    MessengerDate
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
